import React from "react";
import "./InnerSection.css";
import kim from "../../assets/images/ratings/Kim-Kardashian-2008.webp"
import roseanne from "../../assets/images/ratings/Roseanne-Barr.webp"
import charlie from "../../assets/images/ratings/CharlieSheen.jpeg"
import mel from "../../assets/images/ratings/MelGibson.jpeg"
import johnny from "../../assets/images/ratings/JohnnyDepp.jpg"
import alec from "../../assets/images/ratings/AlecBaldwin.jpg"

const data = [
  {
    name: "Kim Kardashian",
    role: "TV Personality",
    img: kim
  },
  {
    name: "Roseanne-Barr",
    role: "TV Personality",
    img: roseanne
  }
];

const data1 = [
   {
    name: "Charlie Sheen",
    role: "TV Personality",
    img: charlie
  },  
  {
    name: "Mel Gibson",
    role: "TV Personality",
    img: mel
  }
];
const data2 = [
  {
    name: "Johnny Depp",
    role: "TV Personality",
    img: johnny
  },
 
  {
    name: "Alec Baldwin",
    role: "TV Personality",
    img: alec
  }
];


const InnerSection = () => {
  return (
    <div className="reality-tv-container">
      <h2 className="reality-tv-title">Who are your favorite tv stars? </h2>
      {/* <p className="reality-tv-subtitle">  
      </p> */}

      {/* <div className="search-bar-container">
        <input
          type="text"
          placeholder="Search for more suggestions"
          className="search-input"
        />
        <div className="nav-buttons">
          <button className="nav-btn">&#8249;</button>
          <button className="nav-btn">&#8250;</button>
        </div>
      </div> */}

      <div className="cards-container">
        {data.map((person, index) => (
          <div className="card" key={index}>
            <img src={person.img} alt={person.name} className="card-image" />
            <div className="card-info">
              <h3>{person.name}</h3>
              <p>{person.role}</p>
            </div>
          </div>
        ))}
    </div>
    <div className="cards-container">
         {data1.map((person, index) => (
          <div className="card" key={index}>
            <img src={person.img} alt={person.name} className="card-image" />
            <div className="card-info">
              <h3>{person.name}</h3>
              <p>{person.role}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="cards-container">
         {data2.map((person, index) => (
          <div className="card" key={index}>
            <img src={person.img} alt={person.name} className="card-image" />
            <div className="card-info">
              <h3>{person.name}</h3>
              <p>{person.role}</p>
            </div>
          </div>
        ))}
      </div>      
    </div>
  );
};

export default InnerSection;
